// extracted by mini-css-extract-plugin
export default {"headerContainer":"TxBottomComponent_headerContainer__Waq7K","button":"TxBottomComponent_button__zDpeS","noBorder":"TxBottomComponent_noBorder__e9vg5"};